<div class="modal-delete-container">
  <div class="modal-delete-header">
    <h6 class="modal-delete-title">
      <span class="item-name">{{T.common.include_images_attached | translate}}</span>
    </h6>
  </div>
  <div class="modal-delete-content">
    <div class="modal-delete-message">{{T.common.include_images_attached_info_text | translate}}</div>
  </div>
  <div class="modal-delete-footer">
    <div class="modal-delete-buttons">
      <app-button-rectangle
        class="cancel-button"
        [text]="T.common.do_not_include | translate"
        (clicked)="onCancel()"
        buttonTheme="white"
        size="large"
      ></app-button-rectangle>
      <app-button-rectangle
        class="delete-button"
        [text]="T.common.include | translate"
        (clicked)="onInclude()"
        buttonTheme="primary"
        size="large"
      ></app-button-rectangle>
    </div>
  </div>
</div>
